import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../services/api';
import arrayCatcher from '../../../../helpers/errorCatcher';

export const getCategoryListThunk = createAsyncThunk(
  'category/list',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.definitions.categories.list();
      return response.data.data;
    } catch (err: any) {
      arrayCatcher(err?.code);
      return rejectWithValue(err);
    }
  },
);
